import Link from "next/link";
import { CheckBoxIcon } from "../../../page-components/icons";

// TODO: CHANGE FROM PRIVACY TO

const CheckboxRegular = ({ value, setValue, htmlFor, link }) => {
  return (
    <div className="checkbox__regularContainer">
      <label
        className="checkbox__regularLabel checkbox__privacy"
        htmlFor={htmlFor}
      >
        {value ? (
          <CheckBoxIcon
            className="icon--xs checkbox--checked"
            color="white"
            onClick={() => setValue(!value)}
          />
        ) : (
          <CheckBoxIcon
            className="icon--xs checkbox--unchecked"
            color="white"
            onClick={() => setValue(!value)}
          />
        )}

        <input
          name={htmlFor}
          className="checkbox__regularCheckbox"
          type="checkbox"
          required
        />
        <p>
          I agree to the{" "}
          <Link href={link}>
            <a target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </Link>
        </p>
      </label>
    </div>
  );
};

export default CheckboxRegular;
